import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Novita } from "@/components/Novita";
import { Storia } from "@/components/Storia";
import { Prodotti } from "@/components/Prodotti";
import { Torte } from "@/components/Torte";
import { Contatti } from "@/components/Contatti";
import { Footer } from "@/components/Footer";
import { MobileWhatsAppButton } from "@/components/MobileWhatsAppButton";
import { AnnouncementPopup } from "@/components/AnnouncementPopup";
import BoxApericena from "@/components/BoxApericena";

const Home = () => (
  <>
    <main>
      <Hero />
      <Novita />
      <Storia />
      <Prodotti />
      <Torte />
      <Contatti />
    </main>
    <AnnouncementPopup />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    if (window.location.pathname === "/" && window.location.hash) {
      setTimeout(() => {
        const el = document.querySelector(window.location.hash);
        if (el) lenis.scrollTo(el, { offset: -70 });
      }, 600);
    }
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/box" element={<BoxApericena />} />
        </Routes>
        <Footer />
        <MobileWhatsAppButton />
      </div>
    </BrowserRouter>
  );
}

export default App;
